const PROCTORING_TYPES = {
    INTEGRITY_ADVOCATE: "Integrity Advocate",
    PROCTORIO: "Proctorio",
    OCTO_PROCTOR: "OctoProctor"
};

export { PROCTORING_TYPES };
